/**
 * Event bus for Vue 3 (replaces Vue 2's $root.$on/$emit which was removed).
 * Use mitt - a tiny event emitter compatible with Vue 3.
 */
import mitt from 'mitt'

export function createEventBus() {
  return mitt()
}
